module.exports = __webpack_public_path__ + "img/selected7-min.b1122520.png";